import React, { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom'
const Login = lazy(() => import('./pages/login/Login'))
const Password = lazy(() => import('./pages/password/Password'))
const ForgotPassword = lazy(() => import('./pages/forgot-password/ForgotPassWord'))
const ForgotUsername = lazy(() => import('./pages/forgot-username/ForgotUsername'))
const UpdatePassword = lazy(() => import('./pages/update-password/UpdatePassword'))
const Expired = lazy(() => import('./pages/expired/Expired'))
const TwoFactorSetup = lazy(() => import('./pages/two-factor-setup/TwoFactorSetup'))
const SignInCertificate = lazy(() => import('./pages/sign-in-certificate/SignInCertificate'))
const GenerateCertificate = lazy(() => import('./pages/sign-in-certificate/GenerateCertificate'))
const VerifyOtp = lazy(() => import('./pages/verify-otp/VerifyOtp'))
import { expired, forgotPassWord, forgotUserName, login, password, twoFactorSetup, updatePassWord, resetPassword, verifyOtp, signInCertificate, generateCertificate, certificateError } from './utils/routes'
import LogInLayout from './layouts/login/LogInLayout'
import CertificateError from 'pages/sign-in-certificate/CertificateError';

const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<LogInLayout/>}>
        <Route path={login} element={<Login/>} />
        <Route path={password} element={<Password/>} />
        <Route path={forgotPassWord} element={<ForgotPassword/>} />
        <Route path={forgotUserName} element={<ForgotUsername/>} />
        <Route path={updatePassWord} element={<UpdatePassword/>} />
        <Route path={resetPassword} element={<UpdatePassword/>} />
        <Route path={expired} element={<Expired/>} />
        <Route path={twoFactorSetup} element={<TwoFactorSetup/>} />
        <Route path={signInCertificate} element={<SignInCertificate/>} /> 
        <Route path={generateCertificate} element={<GenerateCertificate/>} />
        <Route path={certificateError} element={<CertificateError/>} />
        <Route path={verifyOtp} element={<VerifyOtp/>} />
    </Route>
  )
)

export default AppRouter;
